import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable, of } from 'rxjs';
import { Machine, MachineInspection } from '../models/machine.model';
import { map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class MachinesService {
  private machinesCache: Machine[] | null = null;

  constructor(protected apiService: ApiService) {}

  // getMachines() {
  //   if (this.machinesCache) {
  //     return of(this.machinesCache);
  //   }

  //   return this.apiService.get('/machines').pipe(
  //     map((machines: Machine[]) => machines.map((m) => Object.assign(new Machine(), m))),
  //     tap((machines: Machine[]) => {
  //       this.machinesCache = machines;
  //     })
  //   );
  // }

  // getMachineBySerialNumber(serialNumber: string) {
  //   return this.getMachines().pipe(map((machines: Machine[]) => machines.find((m) => m.serialNumber === serialNumber)));
  // }

  // getMachineInspections(serial: string): Observable<MachineInspection[]> {
  //   return this.apiService
  //     .get(`/machines/${serial}/inspections`)
  //     .pipe(map((inspections: MachineInspection[]) => inspections.map((m) => Object.assign(new MachineInspection(), m))));
  // }

  // getInspectionsMachines(id: string): Observable<Machine[]> {
  //   return this.apiService
  //     .get(`/inspections/${id}/machines`)
  //     .pipe(map((machines: Machine[]) => machines.map((m) => Object.assign(new Machine(), m))));
  // }

  // getCustomerMachines(id: string): Observable<Machine[]> {
  //   return this.apiService
  //     .get(`/customers/${id}/machines`)
  //     .pipe(map((machines: Machine[]) => machines.map((m) => Object.assign(new Machine(), m))));
  // }
}
